import { render, staticRenderFns } from "./LmUploadFiles.vue?vue&type=template&id=2276f2e1&scoped=true"
import script from "./LmUploadFiles.vue?vue&type=script&lang=js"
export * from "./LmUploadFiles.vue?vue&type=script&lang=js"
import style0 from "./LmUploadFiles.vue?vue&type=style&index=0&id=2276f2e1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2276f2e1",
  null
  
)

export default component.exports